import { Box, Typography } from '@mui/material';
import ReusableGrid from '../../../../components/Grid';
import { useMemo } from 'react';
import { GROUPBY } from '../../../../constants/Reports';

const commonHeaders = [
  {
    headerName: 'Date',
    field: 'date',
  },
  {
    headerName: 'Shift',
    field: 'shift',
  },
  {
    headerName: 'Type',
    field: 'type',
  },
  {
    headerName: 'Hours',
    field: 'hours',
  },
];

const HEADERS = (param) =>
  param === GROUPBY[0].value
    ? commonHeaders
    : [
        {
          headerName: 'Name',
          field: 'name',
        },
        ...commonHeaders,
      ];

export const Card = ({ data, title, groupBy }) => {
  const gridHeaders = useMemo(() => HEADERS(groupBy), [groupBy]);
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
      }}
    >
      <Typography fontWeight={600} variant="h5">
        {title}
      </Typography>
      {data.length === 0 ? (
        <Typography
          sx={{ textAlign: 'center', mt: '32px' }}
          fontWeight={700}
          variant="h5"
        >
          No data available
        </Typography>
      ) : (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
          {data.map((item) => (
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
              {item.name && (
                <Typography fontWeight={500} variant="h6">
                  {item.name}
                </Typography>
              )}

              <ReusableGrid columns={gridHeaders} rows={item.items} />
            </Box>
          ))}
        </Box>
      )}
    </Box>
  );
};
